import type { ParticipantEditRule } from './types'

export function isExternallyEditable(rule: ParticipantEditRule): boolean {
  return rule.editionType === 'ExternalEditable'
}
